export const isEmpty = (value) => {
    if (!value) return true;

    // Verifica se é um array vazio
    if (Array.isArray(value) && value.length === 0) {
        return true;
    }

    // Verifica se é um objeto vazio
    if (typeof value === 'object' && value !== null && Object.keys(value).length === 0) {
        return true;
    }

    return false;
};